export default __webpack_public_path__ + "static/OpenSans-Bold-c2588d9443bcab1b8bd92ff30c546748.woff";